export enum MixMatchType {
    UnknownError = "UnknownError",
    ExxonMobilPackage = "ExxonMobilPackage",
    ExxonMobilSynthetic = "ExxonMobilSynthetic",
    ExxonMobilBulk = "ExxonMobilBulk",
    SpectrumOil = "SpectrumOil",
    SpectrumAntiFreeze = "SpectrumAntiFreeze",
    StarterBatteries = "StarterBatteries",
    ECCO = "ECCO",
}
